/**
 * Google Analytics 4 helper.
 * Se activa solo si REACT_APP_GA_MEASUREMENT_ID está definido.
 * SPA-aware: expone trackPageview y trackEvent.
 */

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

export const isGAEnabled = () => Boolean(GA_ID);

export const initGA = () => {
  if (!isGAEnabled() || initialized || typeof window === "undefined") return;
  initialized = true;

  // Inject gtag.js script
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  // send_page_view=false: manejamos pageviews manualmente en el router
  window.gtag("config", GA_ID, { send_page_view: false });
};

export const trackPageview = (path, title) => {
  if (!isGAEnabled() || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: title || document.title,
  });
};

export const trackEvent = (name, params = {}) => {
  if (!isGAEnabled() || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
};
